import { Rectangle, Sprite } from 'pixi.js';
import { EVENT, IMAGES, MainSignals, TickCallData } from '../../../../settings/constants';
import { SCENE_0 } from '../../../../settings/positions';
import SceneBase from '../base/SceneBase';
import DarkCloud from './DarkCloud';
import { TweenMax, Power1 } from 'gsap';
import { playSfx, swapMusic } from '../../../../helpers/SoundManager';

const HIT_AREA = [-600, -400, 1200, 650];
export default class Scene0 extends SceneBase {
  bg: Sprite;
  char: Sprite;
  clouds: DarkCloud[] = [];

  charVisible = false;
  darkState = false;
  cloudsVisible = false;

  duration = 0;

  soundDelayChar: any = null;

  constructor(signals: MainSignals) {
    super(signals, SCENE_0, 0, null);

    // vars
    this.duration = this.hideStart - this.show;

    // parts
    this.bg = Sprite.from(IMAGES.BG_0);
    this.bg.anchor.set(0.5);
    this.addChild(this.bg);

    // clouds
    this.setCloud('0-cloud-0.png', -560, 20);
    this.setCloud('0-cloud-1.png', -20, -280);
    this.setCloud('0-cloud-2.png', 430, -140);
    this.setCloud('0-cloud-3.png', 580, 40);

    const overlay = Sprite.from(IMAGES.OVERLAY_0);
    overlay.anchor.set(0.5);
    this.addChild(overlay);

    this.char = Sprite.from('0-char.png');
    this.char.alpha = 0;
    this.char.anchor.set(0.5);
    this.addChild(this.char);

    // interaction
    this.hitArea = new Rectangle(HIT_AREA[0], HIT_AREA[1], HIT_AREA[2], HIT_AREA[3]);
    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', this.handleWindowsDown.bind(this));

    // for hit area debug
    // setTimeout(() => {
    //   const hit = new Graphics();
    //   hit.beginFill(0xff0000, 0.2);
    //   hit.drawRect(HIT_AREA[0], HIT_AREA[1], HIT_AREA[2], HIT_AREA[3]);
    //   hit.endFill();
    //   this.addChild(hit);
    // }, 100);

    // listeners
    signals.stateCall.add(this.stateCall, this);
  }

  stateCall(event: string, value: string): void {
    if (event === EVENT.STATE.SPEECH_DONE && value !== '0-0') {
      setTimeout(() => {
        this.handleWindowsDown();
      }, 1500);
    }
  }

  handleWindowsDown(): void {
    if (this.isActive) {
      this.setDarkState(!this.darkState);
      this.showCloouds(!this.cloudsVisible);
    }
  }

  // --------------------------------------------------------------
  // Character
  // --------------------------------------------------------------

  checkChar(value: number): void {
    this.showChar(value > this.duration * 0.333 && value <= this.hideEnd);
  }

  showChar(value: boolean): void {
    if (this.charVisible !== value) {
      this.charVisible = value;

      TweenMax.killTweensOf(this.char);
      if (this.charVisible) {
        TweenMax.to(this.char, 0.8, { alpha: 1, ease: Power1.easeInOut });
        this.soundDelayChar = setTimeout(() => {
          playSfx('0-char-show');
        }, 100);
      } else {
        TweenMax.to(this.char, 0.4, { alpha: 0, ease: Power1.easeInOut });
        clearTimeout(this.soundDelayChar);
      }
    }
  }
  // --------------------------------------------------------------
  // Dark bg
  // --------------------------------------------------------------

  setDarkState(value: boolean): void {
    if (this.darkState !== value) {
      this.darkState = value;

      TweenMax.killTweensOf(this.bg);
      if (this.darkState) {
        TweenMax.to(this.bg, 0.9, { x: 215, ease: Power1.easeInOut });
        swapMusic(100);
        this.musicId = 100;
      } else {
        TweenMax.to(this.bg, 0.6, { x: 0, ease: Power1.easeInOut });
        swapMusic(0);
        this.musicId = 0;
      }
    }
  }

  // --------------------------------------------------------------
  // Clouds
  // --------------------------------------------------------------

  setCloud(textureName: string, x: number, y: number): void {
    const cloud = new DarkCloud(textureName, x, y);
    this.addChild(cloud);
    this.clouds.push(cloud);
  }

  showCloouds(value: boolean): void {
    if (this.cloudsVisible !== value) {
      this.cloudsVisible = value;

      this.clouds.forEach((cloud) => {
        cloud.show(this.cloudsVisible);
      });
    }
  }

  // --------------------------------------------------------------
  // State switching
  // --------------------------------------------------------------

  tickCall(data: TickCallData): void {
    super.tickCall(data);

    // check states
    const { scroll } = data;
    this.checkChar(scroll);
  }
}
